import request from '@/utils/request'


// 查询爆品列表
export function listGoodsExplosive(query) {
  return request({
    url: '/goods/goods/explosive/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询爆品分页
export function pageGoodsExplosive(query) {
  return request({
    url: '/goods/goods/explosive/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询爆品详细
export function getGoodsExplosive(data) {
  return request({
    url: '/goods/goods/explosive/detail',
    method: 'get',
    params: data
  })
}

// 新增爆品
export function addGoodsExplosive(data) {
  return request({
    url: '/goods/goods/explosive/add',
    method: 'post',
    data: data
  })
}

// 修改爆品
export function updateGoodsExplosive(data) {
  return request({
    url: '/goods/goods/explosive/edit',
    method: 'post',
    data: data
  })
}

// 删除爆品
export function delGoodsExplosive(data) {
  return request({
    url: '/goods/goods/explosive/delete',
    method: 'post',
    data: data
  })
}
